import type { AxiosInstance } from 'axios';
import { BaseService } from './BaseService';
import type { StatusViewModel, StatusCreateModel, StatusUpdateModel } from '../types/status';
import { apiClient } from '../client/client';

export class StatusService extends BaseService<
  StatusViewModel,
  StatusCreateModel,
  StatusUpdateModel,
  StatusViewModel[]
> {
  private static readonly BASE = '/api/status';

  constructor(client: AxiosInstance = apiClient) {
    super(client, StatusService.BASE);
  }
}

export const statusService = new StatusService();
